import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { fetchProducts } from '../../api';
import { useAuth } from '../../context/AuthContext';
import './Services.scss';

const CATEGORIES = [
  { key: 'all', label: '全部' },
  { key: 'furniture', label: '家居产品' },
  { key: 'survey', label: '勘察服务' },
];

function Services() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [category, setCategory] = useState('all');
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    setLoading(true);
    fetchProducts(category).then((list) => {
      if (!mounted) return;
      setProducts(list);
      setLoading(false);
    });
    return () => {
      mounted = false;
    };
  }, [category]);

  const handleCardClick = (p) => {
    if (p.isPaid) {
      // 付费服务：未登录跳登录页，已登录跳付费页
      if (!user) {
        navigate('/login?redirect=/payment');
        return;
      }
      navigate('/payment');
      return;
    }
    navigate(`/services/${p.id}`);
  };

  return (
    <div className="services">
      <section className="page-banner">
        <div className="container">
          <h1>产品服务</h1>
          <p>家居与生活服务，一站式解决方案</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {/* 分类筛选 */}
          <div className="filter-tabs">
            {CATEGORIES.map((c) => (
              <button
                key={c.key}
                className={category === c.key ? 'tab active' : 'tab'}
                onClick={() => setCategory(c.key)}
              >
                {c.label}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="page-loading">加载中...</div>
          ) : (
            <div className="product-grid">
              {products.map((p) => (
                <div
                  className={`product-card ${p.isPaid ? 'product-paid' : 'product-clickable'}`}
                  key={p.id}
                  onClick={() => handleCardClick(p)}
                >
                  <div className="product-icon">{p.icon}</div>
                  <h3>{p.title}</h3>
                  <p>{p.desc}</p>
                  <div className="product-tags">
                    {p.features.map((f) => (
                      <span key={f}>{f}</span>
                    ))}
                  </div>
                  <span className="product-more">{p.isPaid ? '付费咨询 →' : '查看详情 →'}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* 服务流程 */}
      <section className="section section-gray">
        <div className="container">
          <h2 className="section-title">服务流程</h2>
          <p className="section-sub">四步轻松搞定，省心更省力</p>
          <div className="process-grid">
            {[
              { step: '01', title: '预约咨询', desc: '在线或到店预约，顾问一对一对接' },
              { step: '02', title: '方案定制', desc: '免费量房设计，定制专属家居方案' },
              { step: '03', title: '签约执行', desc: '透明报价签约，高效准时交付' },
              { step: '04', title: '交付售后', desc: '准时交付验收，10年质保跟踪服务' },
            ].map((s) => (
              <div className="process-card" key={s.step}>
                <span className="process-step">{s.step}</span>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
          <div className="center">
            <Link to="/contact" className="btn btn-primary">
              立即预约咨询
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;
